import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Bell } from "lucide-react";
import NotificationPreferences from "@/components/NotificationPreferences";

export default function NotificationsSettings() {
  return (
    <div className="min-h-screen bg-background" data-testid="notifications-settings-page">
      <header className="border-b border-border bg-background/95 backdrop-blur sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center gap-3">
          <Link to="/profile" className="rounded-full p-2 hover:bg-muted transition-colors" data-testid="notif-back">
            <ArrowLeft className="w-4 h-4" />
          </Link>
          <div className="flex items-center gap-2">
            <Bell className="w-4 h-4 text-primary" />
            <h1 className="text-sm font-bold tracking-tight">Configurações · Notificações</h1>
          </div>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-6">
        <NotificationPreferences />
      </main>
    </div>
  );
}
